module.exports = __webpack_public_path__ + "static/fonts/fa-solid-900.b6a14bb.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/fa-solid-900.ttf
// module id = tR0v
// module chunks = 0